<div class="version-container"><span [translate]="'version.text'"></span>:&nbsp;<span>#version</span></div>
